<script>
    import store from "../../store";
    import Errors from '../../helpers/Errors';

    import QuotePanel from '../onboarding/QuotePanel';
    import PackagePanel from '../onboarding/PackagePanel';
    import TelephoneInput from '../telephoneinput/TelephoneInput';

    export default {
        name: "SetupAccountForm",

        props: [ 'old', 'errorMessages', 'package', 'invite' ],

        components: {
            PackagePanel,
            QuotePanel,
            TelephoneInput
        },

        data() {
            return {
                fields : {
                    first_name : '',
                    last_name : '',
                    email : '',
                    telephone_number : {
                        country_code: '',
                        national_number: ''
                    },
                    birthday : {
                      day : '',
                      month: '',
                      year: ''
                    },
                    nationality:'GB',
                    password : '',
                    password_confirmation : '',
                    terms : false,
                    existing_contracts: false,
                    sharing_permission: false,
                    council_acknowledgement: false,
                    notifications_email : false,
                    notifications_sms : false
                },
                errors: new Errors(JSON.parse(this.errorMessages))
            }
        },

        created() {
            if (this.old) {
                // Fill form with old data
                try {
                    _.merge(this.$data.fields, JSON.parse(this.old));
                } catch (e) {
                    // No old data
                }
            }

            if (this.invite) {
                this.$data.fields.first_name = this.invite.first_name;
                this.$data.fields.last_name = this.invite.last_name;
                this.$data.fields.telephone_number.country_code = this.invite.phone_number.country_code;
                this.$data.fields.telephone_number.national_number = this.invite.phone_number.national_number;
            }
        },

        mounted() {
            store.commit('quote/setBills', this.package);
            store.commit('quote/selectAllBills');
        },

        methods: {

            packageHasProvider(provider) {
                for(let i=0; i<this.package.length; i++) {

                    if(_.has(this.package[i], 'provider') && this.package[i].provider === provider) {
                        return true;
                    } else if(_.has(this.package[i], 'bills')) {
                        for(let j=0; j<this.package[i].bills.length; j++) {
                            if ((this.package[i].bills[j].provider.name) === provider) {
                                return true;
                            }
                        }
                    }
                }
                return false;
            },

            packageHasGroup(group) {
                for(let i=0; i<this.package.length; i++) {
                    if ((this.package[i].name) === group) {
                        return true;
                    }
                }
                return false;
            },

        },

        computed: {

            phone() {
                let number = this.$data.fields.telephone_number;

                if(number.country_code && number.national_number) {
                    return '+' + number.country_code + number.national_number;
                } else {
                    return null;
                }
            },

            passwordRequirement() {
                if(this.$data.errors.has('password')) {
                    return this.$data.errors.get('password');
                } else {
                    return 'Your password must contain a number and 8 characters min';
                }
            }
        }

    }
</script>
